import { Box } from "@mui/material";
import MuiImage from "mui-image";
import { entitiesUrl } from "src/utils/formatUrl";

// ----------------------------------------------------------------------

type Props = {
	name: string;
	id: string;
};

export const EntityImage = ({ name, id }: Props) => {
	return (
		<Box
			height={37}
			sx={{
				display: "flex",
				overflow: "hidden",
				alignItems: "center",
				justifyContent: "center"
			}}
		>
			<MuiImage src={entitiesUrl(id)} alt={name} fit='contain' duration={500} height='auto' />
		</Box>
	);
};

export default EntityImage;
